import { Component, HostListener, inject } from '@angular/core';

import { CommonModule } from '@angular/common';

import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-backoffice-layout',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './backoffice-layout.html',
  styleUrl: './backoffice-layout.css',
})
export class BackofficeLayout {
  private readonly router = inject(Router);
  private readonly auth = inject(AuthService);

  menuAberto = false;

  get perfil(): string {
    return this.auth.perfil ?? '';
  }

  get isAdmin(): boolean {
    return this.router.url === '/admin' || this.router.url.startsWith('/admin/');
  }

  get nomeUsuario(): string {
    return this.auth.nomeUsuario;
  }

  get iniciais(): string {
    return this.nomeUsuario
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((nome) => nome.charAt(0))
      .join('')
      .toUpperCase();
  }

  fecharMenu(): void {
    this.menuAberto = false;
  }

  sair(): void {
    this.auth.logout();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.fecharMenu();
  }
}
